/**
 * @function `calcScrollbar`
 *
 * Sets the custom property `--scrollbarWidth` to the width of the scrollbar in pixels.
 */
const calcScrollbar = () => {
    const width = window.innerWidth - document.body.offsetWidth
    document.documentElement.style.setProperty('--scrollbarWidth', `${width}px`);
};

const init = () => {
    calcScrollbar();

    window.addEventListener('resize', () => {
        calcScrollbar();
    });
};

export default init;